/**
 * Formats option values into human-readable labels
 * Handles special cases like 'astar' -> 'A*'
 * @param {string} value - The option value (e.g., 'astar', 'manhattan', 'flow-square')
 * @param {string} [type] - Optional type hint ('algorithm', 'heuristic', 'layout')
 * @returns {string} Human-readable label
 */
const formatOptionLabel = (value, type = null) => {
  const specialCases = {
    astar: 'A*',
    dijkstra: 'Dijkstra',
    manhattan: 'Manhattan',
    euclidean: 'Euclidean',
    'bidirectional': 'Bidirectional',
  };

  // Check for special case
  if (specialCases[value]) {
    return specialCases[value];
  }

  // For hyphenated values like 'flow-square', 'random-shortest-square'
  if (value.includes('-')) {
    return value
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  // Default: capitalize first letter
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export default formatOptionLabel;
